function initMobileSlider(sectionSelector, listSelector, prevSelector, nextSelector) {
  const section = document.querySelector(sectionSelector);
  if (!section) return;

  const list = section.querySelector(listSelector);
  const prevBtn = section.querySelector(prevSelector);
  const nextBtn = section.querySelector(nextSelector);

  if (!list || !prevBtn || !nextBtn) return;

  // Працюємо тільки на мобайлі
  function isMobile() {
    return window.innerWidth < 1200;
  }

  nextBtn.addEventListener('click', () => {
    if (!isMobile()) return;
    list.scrollBy({ left: 320, behavior: 'smooth' });
  });

  prevBtn.addEventListener('click', () => {
    if (!isMobile()) return;
    list.scrollBy({ left: -320, behavior: 'smooth' });
  });
}

/* Ініціалізація */

initMobileSlider(
  '.players-section',
  '.players-steps',
  '.btn-prev',
  '.btn-next'
);

initMobileSlider(
  '.about-section',
  '.about-steps',
  '.btn-prev',
  '.btn-next'
);
